import { Stack } from '@mui/material';
import { Dispatch, FC, SetStateAction } from 'react';

import {
  CalendarEvent,
  InterviewBlock,
  UserEvent,
} from '@features/enterpriseEvents';
import { white } from '@styles/colors';
import { Application } from '@features/applications';
import UpcomingInterviews from '../UpcomingInterviews/UpcomingInterviews';
import InterviewMarkers from '../InterviewMarkers/InterviewMarkers';
import ApplicantEventInfoModal from '@features/events/components/ApplicantEventInfoModal/ApplicantEventInfoModal';

type UpcomingEventsProps = {
  upcomingInterviews: CalendarEvent[];
  setSelectedApplication: Dispatch<SetStateAction<Application | null>>;
  selectedApplication: Application | null;
  singleBlockInterview: InterviewBlock | UserEvent | null;
  setSingleBlockInterview: Dispatch<
    SetStateAction<InterviewBlock | UserEvent | null>
  >;
};

const UpcomingEvents: FC<UpcomingEventsProps> = ({
  upcomingInterviews,
  setSelectedApplication,
  selectedApplication,
  singleBlockInterview,
  setSingleBlockInterview,
}) => {
  return (
    <>
      <InterviewMarkers />
      <Stack
        bgcolor={white}
        p={3}
        borderRadius={8}
        spacing={3}
        sx={{ width: '100%' }}
      >
        <UpcomingInterviews
          upcomingInterviews={upcomingInterviews}
          setSingleBlockInterview={setSingleBlockInterview}
        />
      </Stack>
      {singleBlockInterview && (
        <ApplicantEventInfoModal
          event={singleBlockInterview}
          handleClose={() => setSingleBlockInterview(null)}
          setSelectedApplication={setSelectedApplication}
          selectedApplication={selectedApplication}
        />
      )}
    </>
  );
};

export default UpcomingEvents;
